import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Header from '../../Header';
import Sidebar from '../../Sidebar';
import Footer from '../../Footer';
import { Circles } from 'react-loader-spinner'; 
import '../main.css';
import { toast } from "react-toastify";
import { Switch, FormControlLabel } from "@mui/material";
import { enable2FA, disable2FA } from '../../../redux/actions/userActions';

const Auth2FA = () => {
    const dispatch = useDispatch();
    const { loading = false, is2FAEnabled = false } = useSelector(state => state.auth || {});
    const [enabled, setEnabled] = useState(is2FAEnabled);

    const handleToggle = () => {
        if (enabled) {
            dispatch(disable2FA());
            toast.info("Two-Factor Authentication Disabled");
        } else {
            dispatch(enable2FA());
            toast.success("Two-Factor Authentication Enabled");
        }
        setEnabled(!enabled);
    };

    return (
        <div className="container-scroller">
            <Header />
            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <div className="row">
                            <div className="col-12 grid-margin">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title">Two-Factor Authentication</h4>
                                        <p>Secure your account by enabling Two-Factor Authentication (2FA).</p>
                                        <div className="d-flex align-items-center mt-4">
                                            <FormControlLabel
                                                control={<Switch checked={enabled} onChange={handleToggle} color="primary" />}
                                                label={enabled ? "Enabled" : "Disabled"}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
            {loading && (
                <div className="fullscreen-loader">
                    <Circles color="#F1B621" height={80} width={80} />
                </div>
            )}
        </div>
    );
};

export default Auth2FA;